// extracted by mini-css-extract-plugin
module.exports = {"news_main":"News_news_main__1VNW6","sasd":"News_sasd__3oybE","main":"News_main__2WrvZ","title":"News_title__bHhMK","time":"News_time__D1YDw"};